import { Info } from "lucide-react";

/**
 * Consistent, compact demo disclaimer used across patient-facing pages.
 * Keeps every hospital / doctor / price / result clearly labelled as demo data.
 */
export default function DemoNote({
  text,
  className = "",
}: {
  text: string;
  className?: string;
}) {
  return (
    <div
      className={`mx-5 mt-3 flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 ${className}`}
    >
      <Info size={15} className="text-amber-700 mt-[1px] shrink-0" />
      <p className="text-[11.5px] leading-[1.55] text-amber-800">{text}</p>
    </div>
  );
}
